import { CountryModel, RoleModel, TradingGroupAccountModel, TradingGroupWithAccountsModel } from '@spa/api';

export class SortingHelper {
    private constructor() {
    }

    static sortGroupsAlphabetically(groups: TradingGroupWithAccountsModel[]): TradingGroupWithAccountsModel[] {
        return groups.sort((
            currentGroup: TradingGroupWithAccountsModel,
            nextGroup: TradingGroupWithAccountsModel
        ) => {
            const currentGroupName =
                currentGroup.groupName ? currentGroup.groupName.toLowerCase() : currentGroup.groupReferenceId.toLowerCase();

            const nextGroupName = nextGroup.groupName ? nextGroup.groupName.toLowerCase() : nextGroup.groupReferenceId.toLowerCase();

            if (currentGroupName < nextGroupName) {
                return -1;
            }

            if (currentGroupName > nextGroupName) {
                return 1;
            }

            return 0;
        });
    }

    static sortAccountsAlphabetically(accounts: TradingGroupAccountModel[]): TradingGroupAccountModel[] {
        return accounts.sort((
            currentAccount: TradingGroupAccountModel,
            nextAccount: TradingGroupAccountModel
        ) => {
            const currentAccountName = currentAccount.accountReferenceId.toLowerCase();
            const nextAccountName = nextAccount.accountReferenceId.toLowerCase();

            if (currentAccountName < nextAccountName) {
                return -1;
            }

            if (currentAccountName > nextAccountName) {
                return 1;
            }

            return 0;
        });
    }

    static sortCountriesAlphabetically(countries: CountryModel[]): CountryModel[] {
        return countries.sort((currentCountry: CountryModel, nextCountry: CountryModel) => {
            const currentCountryName = currentCountry.name.toLowerCase();
            const nextCountryName = nextCountry.name.toLowerCase();

            if (currentCountryName < nextCountryName) {
                return -1;
            }

            if (currentCountryName > nextCountryName) {
                return 1;
            }

            return 0;
        });
    }

    static sortRolesAlphabetically(roles: RoleModel[]): RoleModel[] {
        return roles.sort((currentRole: RoleModel, nextRole: RoleModel) => {
            const currentRoleName = currentRole.name.toLowerCase();
            const nextRoleName = nextRole.name.toLowerCase();

            if (currentRoleName < nextRoleName) {
                return -1;
            }

            if (currentRoleName > nextRoleName) {
                return 1;
            }

            return 0;
        });
    }
}
